const deleteAreasStr = {
  toastr: 'Tipo de documentación eliminada',
  toastr1: 'eliminada con éxito'
};

export default deleteAreasStr;
